import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../app.service";

@Injectable({
  providedIn: "root",
})
export class GlobalSubheaderDataService {
  private apiEP: string = window.apiUrl;
  pharmaExcelExport = new Subject<any>();
  onPharmaExcelExport = this.pharmaExcelExport.asObservable();

  constructor(
    private http: HttpClient,
    private appService: AppService,
  ) {}

  getBreadcrumbsData(params: string): Observable<any> {
    return this.http.get(`${this.apiEP}/api/get_breadcrumb?${params}`);
  }
  getCompanyLevelNotes(ticker: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_company_notes?ticker=${ticker}&is_new=True`,
    );
  }

  getBrokerList(type: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/entitlements/manage/get_brokers_list/?type=${type}`,
    );
  }

  requestBrokers(brokerList): Observable<any> {
    return this.http.post(
      `${this.apiEP}/entitlements/manage/request_broker/`,
      brokerList,
    );
  }
  requestEntitlement(params): Observable<any> {
    return this.http.post(
      `${this.apiEP}/entitlements/manage/request_entitlement/`,
      params,
    );
  }

  requestCorporateEntitlement(params): Observable<any> {
    return this.http.post(
      `${this.apiEP}/ins_ent_api/corporate_entitlement_details/`,
      params,
    );
  }

  downloadFbarModel(params): Observable<any> {
    return this.http.get(`${this.apiEP}${params}`);
  }

  fbarDP(params): Observable<any> {
    return this.http.get(`${this.apiEP}${params}`);
  }

  getFbarModelDetails(params): Observable<any> {
    return this.http.get(`${this.apiEP}${params}`);
  }

  onAction(param): void {
    this.appService.globalSubheaderActionSource.next(param);
  }

  onTemplateAction(actionType): void {
    this.appService.leftPanelTemplateActionSouce.next(actionType);
  }
}
